import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ClientSupportRelationShipBO, ContactInfoLst } from './client-employee-contact.model';

@Injectable({
  providedIn: 'root'
})
export class ClientEmployeeContactService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getLovTypes(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  // Save
  SaveCliContactInfo(saveClientContact: ContactInfoLst): Observable<any> {
    let url = "api/ClientContactInfo/SaveCliContactInfo";
    return this.http.post(url, saveClientContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
   SaveCliSupportInfo(saveClientContact: ClientSupportRelationShipBO): Observable<any> {
    let url = "api/ClientSupportRelationship/SaveClientSupportRelation";
    return this.http.post(url, saveClientContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  SaveEmpContactInfo(saveEmployeeContact: ContactInfoLst): Observable<any> {
    let url = "api/EmployeeContactInfo/SaveEmpContactInfo";
    return this.http.post(url, saveEmployeeContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  
  // Delete
  DeleteCliContactInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientContactInfo/DeleteCliContactInfo?";
    return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

    DeleteCliSupportInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientSupportRelationship/DeleteClientHouseSupportRelationship?";
    return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteEmpContactInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/EmployeeContactInfo/DeleteEmpContactInfo?";
    return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  // get
  getClientInfoDetails(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientContactInfo/GetCliContactInfo?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  
  getEmployeeInfoDetails(paramsData: URLSearchParams): Observable<any> {
    let url = "api/EmployeeContactInfo/GetEmpContactInfo?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

   getsupportplannerDropDown(): Observable<any> {
    let url = "api/ClientSupportRelationship/supportplannerDropDown?";
    return this.http.get<any>(url , { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
